import { Navigate, useLocation } from 'react-router-dom';
import { useUserRole } from '@/providers/RoleProvider';
import LoadingSpinner from '../common/LoadingSpinner';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  pageId: string;
}

const RoleProtectedRoute = ({ children, pageId }: RoleProtectedRouteProps) => {
  const { hasPageAccess, loading, getFirstAllowedUserPath } = useUserRole();
  const location = useLocation();

  // Show loading spinner while checking permissions
  if (loading) {
    return <LoadingSpinner />;
  }

  // Check if user has access to this page
  if (!hasPageAccess(pageId)) {
    // Redirect to first allowed page (not dashboard, which might not be assigned)
    return <Navigate to={getFirstAllowedUserPath()} state={{ from: location }} replace />;
  }

  // User has access, render the page
  return <>{children}</>;
};

export default RoleProtectedRoute;

